module.exports = __webpack_public_path__ + "449a767ff0111fb4050f0c6e72dc4edd.jpg";